import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConsumptionCeilingComponent } from './components/consumption-ceiling/consumption-ceiling.component';
import { TariffComponent } from './components/tariff/tariff.component';
import { AddUserComponent } from './components/users/add-user/add-user.component';
import { AnonymousUsersComponent } from './components/users/anonymous-users/anonymous-users.component';
import { EditUserComponent } from './components/users/edit-user/edit-user.component';
import { UsersListComponent } from './components/users/users-list/users-list.component';
import { AddVehicleComponent } from './components/vehicles/add-vehicle/add-vehicle.component';
import { VehiclesListComponent } from './components/vehicles/vehicles-list/vehicles-list.component';

const routes: Routes = [
  {
    path: 'users',
    children: [
      { path: 'add-user', component: AddUserComponent },
      { path: 'list', component: UsersListComponent },
      { path: 'edit', component: EditUserComponent },
      { path: 'anonymous', component: AnonymousUsersComponent }
    ]
  },
  {
    path: 'vehicles',
    children: [
      { path: 'add-vehicle', component: AddVehicleComponent },
      { path: 'list', component: VehiclesListComponent }
    ]
  },
  {
    path: 'consumption',
    children: [
      { path: 'ceiling', component: ConsumptionCeilingComponent },
    ]
  },
  { path: 'tariff', component: TariffComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FleetManagementRoutingModule { }
